/**
 * Utility function to clean data before sending to API
 * Removes system-generated fields that should not be sent in create/update requests
 */
export const cleanDataForAPI = (data: any): any => {
  if (!data) return data;
  
  // List of fields to always remove
  const fieldsToRemove = [
    'id',
    'createdAt',
    'updatedAt',
    'createdBy',
    'updatedBy',
    'deletedAt',
    'deletedBy',
    // Relation fields that are often populated but shouldn't be sent
    'parent',
    'children',
    'plant',
    'company',
    'workCenters',
    'costCenters',
    'items',
    'attributes',
    'conversions',
    'uoms',
    // UI-only fields
    'helpText'
  ];
  
  // Create a copy of the data
  const cleanData = { ...data };
  
  // Remove the fields
  fieldsToRemove.forEach(field => {
    delete cleanData[field];
  });
  
  // Also remove any null or undefined parentId fields
  if (cleanData.parentId === null || cleanData.parentId === undefined || cleanData.parentId === '') {
    delete cleanData.parentId;
  }
  
  return cleanData;
};

/**
 * Convert string values to numbers for specified numeric fields
 */
export const convertNumericFields = (data: any, numericFields: string[]): any => {
  const result = { ...data };
  
  numericFields.forEach(field => {
    if (result[field] !== undefined && result[field] !== '') {
      const numValue = parseFloat(result[field]);
      if (!isNaN(numValue)) {
        result[field] = numValue;
      }
    }
  });
  
  return result;
};

/**
 * Clean data specifically for update operations
 * Also removes fields that cannot be changed after creation
 */
export const cleanDataForUpdate = (data: any, immutableFields: string[] = []): any => {
  const cleanData = cleanDataForAPI(data);
  
  // Remove any additional immutable fields
  immutableFields.forEach(field => {
    delete cleanData[field];
  });
  
  return cleanData;
};